import { procurementAPI } from "../../axios";

export const actions = {

    //PackageItem
    GetPackageItemByPackage(context, data){
        return procurementAPI.get(`PackageItem/ItemPackage/${data}`);
    },
    GetSinglePackageItem(context, data){
        return procurementAPI.get(`PackageItem/${data}`);
    },
    UpdatePackageItem(context, data){
        return procurementAPI.put(`PackageItem/${data.id}`, data);
    },
    DeletePackageItem(context, data){
        return procurementAPI.delete(`PackageItem/${data}`);
    },
    CreatePackageItem(context, data){
        return procurementAPI.post(`PackageItem/Create`, data);
    },
    CreateMultiplePackageItem(context, data){
        return procurementAPI.post(`PackageItem/Create/multiple`, data);
    },

}